<!-- SHOW SELECTED EVENT ========================================================= -->
<office-modal [isOpen]="true" (requestClose)="closeEventSelected()">
	<office-modal-container
		*ngIf="!showReasonsModal"
		[transparent]="true"
		[footerBorder]="true"
	>
		<!-- Header -->
		<div class="appointment-details--header" header *ngIf="!isLoading">
			<div class="zk-flex zk-justify-between zk-gap-2 zk-items-center">
				<div class="title zk-flex zk-gap-3">
					<h1 *ngIf="event || activeSidebar.type === 'busyslot'">
						{{
							event?.status !== 'reserved'
								? event?.userName ||
								  ('SCHEDULE.SESSIONTYPES.PERSONAL' | translate)
								: ('GENERAL.PENDING' | translate)
						}}
					</h1>
					<freud-tag
						*ngIf="isFirstSession"
						[value]="'GENERAL.FIRST_SESSION' | translate"
					></freud-tag>
				</div>
				<div class="zk-flex zk-gap-2">
					<button
						pTooltip="{{ 'GENERAL.CHAT' | translate }}"
						tooltipPosition="bottom"
						[disabled]="!showChatButton"
						(click)="showChat(event)"
						*ngIf="showChatButton"
					>
						<span class="freud-icon freud-icon-messages freud-icon-md"></span>
					</button>
					<button
						*ngIf="event"
						pTooltip="{{ 'GENERAL.SEE_CONTACT_PROFILE' | translate }}"
						tooltipPosition="bottom"
						(click)="trackPromptuaryListRedirect()"
					>
						<a
							[href]="'/contact/' + event?.contactId"
							class="freud-icon freud-icon-user freud-icon-md"
						></a>
					</button>
					<button class="modal-close" (click)="closeEventSelected()">
						<span class="freud-icon freud-icon-close freud-icon-md"></span>
					</button>
				</div>
			</div>
			<div>
				<details-contact-info
					*ngIf="contact"
					[contact]="contact"
					[payment]="event.paymentMethod"
				></details-contact-info>
			</div>
		</div>

		<!-- Body -->
		<section
			id="calendar-sidebar"
			class="appointment-details"
			[@enterAnimation]
			body
		>
			<div class="row">
				<!-- While is loading. -->
				<div
					*ngIf="isLoading"
					class="zk-flex zk-items-center zk-justify-center details-loading"
				>
					<freud-loader size="lg"></freud-loader>
				</div>

				<!-- Appointment details. -->
				<div *ngIf="!isLoading && busySlotFound">
					<div class="apDetails-session" [@changeAnimation]="dataUpdated">
						<div>
							<!-- Date. -->
							<div class="aps-block">
								<p class="aps-title" *ngIf="busySlotFound">
									{{ 'SCHEDULE.DATE' | translate }}:
								</p>
								<p class="aps-title" *ngIf="!busySlotFound">
									{{ 'SCHEDULE.SESSIONDATE' | translate }}:
								</p>
								<p class="aps-value">{{ screenDate | lowercase }}</p>
							</div>

							<!-- Hour. -->
							<div class="aps-block">
								<p class="aps-title">
									{{ 'SCHEDULE.SESSIONHOUR' | translate }}:
								</p>
								<p class="aps-value">{{ startHours }} - {{ endHours }}</p>
							</div>

							<!-- Description. -->
							<div class="aps-block-direction-column">
								<p class="aps-title">
									{{ 'SCHEDULE.DESCRIPTION' | translate }}:
								</p>
								<p class="aps-value">{{ busySlot?.description }}</p>
							</div>
						</div>
					</div>
				</div>

				<ng-container *ngIf="!showTriageData; else triageData">
					<div *ngIf="!isLoading && eventFound">
						<!-- Session data. -->
						<div class="apDetails-session" [@changeAnimation]="dataUpdated">
							<div>
								<h2 class="apDetails-session--title-session">
									{{ 'GENERAL.SCHEDULING' | translate }}
								</h2>

								<!-- Type. -->
								<div class="aps-block">
									<p class="aps-title">{{ 'SCHEDULE.TYPE' | translate }}:</p>
									<p class="aps-value" *ngIf="!event.recurringScheduleId">
										{{
											event.professionalAddress
												? ('SCHEDULE.PRESENCIAL' | translate)
												: ('SCHEDULE.ONLINE' | translate)
										}}
										<ng-container *ngIf="isSosRs">
											- {{ event.subscription.sessionModel }}
										</ng-container>
									</p>
									<p class="aps-value" *ngIf="event.recurringScheduleId">
										{{ 'SCHEDULE.ONLINE_RECURRENCY' | translate }}
									</p>
									<p
										class="aps-value"
										*ngIf="
											event.subscription?.sessionModel === 'reception_session'
										"
									>
										{{ 'SCHEDULE.SESSION_MODEL_RECEPTION' | translate }}
									</p>
									<p
										class="aps-value"
										*ngIf="
											event.subscription?.sessionModel === 'coordinated_care'
										"
									>
										{{ 'SCHEDULE.SESSION_MODEL_COORDINATED_CARE' | translate }}
									</p>
									<p
										class="aps-value"
										*ngIf="
											event.subscription?.sessionModel ===
											'screening_coordinated_care'
										"
									>
										{{ 'SCHEDULE.SESSION_MODEL_SCREENING' | translate }}
									</p>
								</div>

								<!-- Location. -->
								<div class="aps-block" *ngIf="event.professionalAddress">
									<p class="aps-title">
										{{ 'SCHEDULE.SESSION_LOCATION' | translate }}
									</p>
									<p class="aps-value">
										{{ event.professionalAddress.name }}
									</p>
									<p class="aps-value">
										{{ event.professionalAddress.street }} -
										{{ event.professionalAddress.number }}
									</p>
								</div>

								<!-- If reschedule event. -->
								<div
									*ngIf="isReschedule"
									class="aps-block alert alert-info"
									role="alert"
								>
									<span
										class="glyphicon glyphicon-exclamation-sign"
										aria-hidden="true"
									></span>
									{{ 'SCHEDULE.STATUS.RESCHEDULEDBYTHECLIENT' | translate }}
								</div>

								<!-- Date. -->
								<div class="aps-block">
									<p class="aps-title" *ngIf="busySlotFound">
										{{ 'SCHEDULE.COMPROMISEDATE' | translate }}:
									</p>
									<p class="aps-title" *ngIf="!busySlotFound">
										{{ 'SCHEDULE.SESSIONDATE' | translate }}:
									</p>
									<p class="aps-value">{{ screenDate | lowercase }}</p>
								</div>

								<!-- Scheduled on. -->
								<div class="aps-block">
									<p class="aps-title">
										{{ 'SCHEDULE.SESSIONCONFIRMDATE' | translate }}:
									</p>
									<p class="aps-value">{{ appointDate | lowercase }}</p>
								</div>

								<!-- Hour. -->
								<div class="aps-block">
									<p class="aps-title">
										{{ 'SCHEDULE.SESSIONHOUR' | translate }}:
									</p>
									<div class="aps-value">
										<p class="mb-0">
											{{ event.startTime }} - {{ event.endTime }}
										</p>
									</div>
								</div>

								<!-- Status. -->
								<div class="aps-block">
									<p class="aps-title">{{ 'GENERAL.STATUS' | translate }}:</p>
									<p class="aps-value">
										{{
											event.noShow
												? ('CONTACT.CONFIRMED_NO_SHOW' | translate)
												: getEventStatus(event)
										}}
									</p>
									<p class="expiration-date"*ngIf="event?.status === 'invite' && event?.inviteExpirationDate">
										{{ 'SCHEDULE.EXPIRE_AT' | translate }} {{
											formatDate(event.inviteExpirationDate)
										}}
									</p>
								</div>

								<!-- If screening journey active. -->
								<div *ngIf="screeningResult" class="aps-block">
									<p class="aps-title">
										{{ 'SCHEDULE.TRIAGERESULT' | translate }}:
									</p>
									<div class="aps-value">
										<p class="mb-0">
											{{ screeningResult }}
										</p>
									</div>
								</div>

								<!-- If screening journey active. -->
								<div *ngIf="journeySessionProgress" class="aps-block">
									<p class="aps-title">
										{{ 'SCHEDULE.JOURNEY.SESSION_PROGRESS.TITLE' | translate }}
									</p>
									<div class="aps-value">
										<p class="mb-0">
											{{ journeySessionProgress.label }}
											<ng-container *ngIf="journeySessionProgress.total > 0">
												{{ 
													'SCHEDULE.JOURNEY.SESSION_PROGRESS.DESCRIPTION' | translate: { 
														current: journeySessionProgress.current, 
														total: journeySessionProgress.total 
													} 
												}}
											</ng-container>
										</p>
									</div>
								</div>

								<!-- Contact Reason. -->
								<div
									*ngIf="
										showConfirmSessionFinished &&
										!event.noShow &&
										event.hasPromptuary
									"
									class="formContainer aps-block mb-0 block"
									style="clear: both; display: inline-block; width: 100%"
								>
									<p class="formFieldTitle aps-title">
										{{ 'SCHEDULE.SESSIONREASON' | translate }}:
									</p>

									<ul
										[ngClass]="{
											'selected-reasons': selectedReasons.length === 0,
											'selected-reasons-with-labels': selectedReasons.length > 0
										}"
									>
										<li
											*ngFor="let subarea of selectedReasons"
											class="subarea-pill selected"
										>
											{{ subarea.name }}
										</li>
									</ul>
								</div>

								<!-- Reschedule link. -->
								<a
									*ngIf="allowReschedule"
									(click)="reschedule()"
									class="font-medium cursor-pointer text-action"
									>{{
										(dateTime.dateTimeIsAfter(event?.dayEnd)
											? 'SCHEDULE.RESCHEDULE_THIS_SESSION'
											: 'SCHEDULE.RESCHEDULE_SESSION_THAT_DID_NOT_OCCUR'
										) | translate
									}}</a
								>

								<!-- Cancel reschedule link. -->
								<a
									*ngIf="event.status == 'invite'"
									(click)="cancelInvite()"
									class="font-medium cursor-pointer"
								>
									{{ 'OPERATIONS.CANCELINVITE' | translate }}
								</a>

								<a
									*ngIf="event.status == 'reschedule_request'"
									(click)="cancelReschedule()"
									class="font-medium cursor-pointer"
								>
									{{ 'OPERATIONS.CANCELRESCHEDULE' | translate }}
								</a>
							</div>

							<div>
								<h2 class="apDetails-session--title-session">
									{{ 'SCHEDULE.RECEIPT_INFO' | translate }}
								</h2>

								<!-- Session type -->
								<div class="aps-block">
									<p class="aps-title">
										{{ 'PAGES.CLIENTS.HEADER.SESSIONTYPE' | translate }}:
									</p>
									<div class="aps-value">
										<appointment-type-badge
											[subscriptionType]="
												event?.compensationInfo?.subscription?.type || null
											"
											[textOnly]="true"
										></appointment-type-badge>
									</div>
								</div>

								<!-- Status. -->
								<div class="aps-block">
									<p class="aps-title">{{ 'GENERAL.STATUS' | translate }}:</p>
									<div class="aps-value">
										<p class="mb-0">
											{{ getPaymentStatus(event) }}
										</p>
									</div>
								</div>

								<!-- Value. -->
								<div
									*ngIf="
										event.status !== 'reserved' &&
										event.status !== 'invite' &&
										(!isProfessionalZen || (event?.isB2C && isProfessionalZen))
									"
									class="aps-block"
								>
									<p class="aps-title">
										{{
											(getFinalCompensation(event) === false &&
											event.professionalCompensation > 0
												? 'SCHEDULE.ESTIMATED_SESSIONVALUE'
												: 'SCHEDULE.SESSIONVALUE'
											) | translate
										}}:
									</p>
									<div class="aps-value">
										<p class="mb-0">{{ professionalProfit.value }}</p>
									</div>
								</div>

								<div
									*ngIf="
										getFinalCompensation(event) === false &&
										event.professionalCompensation > 0 &&
										event.status !== 'reserved' &&
										event.status !== 'invite' &&
										(!isProfessionalZen || (isProfessionalZen && event?.isB2C))
									"
									class="aps-block profit-disclaimer"
								>
									<office-icon
										name="alert"
										style="margin-right: 8px"
									></office-icon>
									<p>{{ 'GENERAL.PROFIT_DISCLAIMER' | translate }}</p>
								</div>

								<div
									*ngIf="
										originalDateFrom && event.professionalCompensation === 0
									"
									class="aps-block profit-disclaimer"
								>
									<office-icon
										name="alert"
										style="margin-right: 8px"
									></office-icon>
									<p>
										{{ 'GENERAL.PROFIT_DISCLAIMER_RESCHEDULE' | translate }}
									</p>
								</div>

								<!-- Discount. -->
								<div
									*ngIf="
										event.status !== 'reserved' && event.status !== 'invite'
									"
									class="aps-block block"
								>
									<p
										*ngIf="
											professionalProfit.extraInfo.length > 0 &&
											(!isProfessionalZen ||
												(event?.isB2C && isProfessionalZen))
										"
										class="aps-title"
										style="margin: 0 0 8px 0"
									>
										<span>{{ 'GENERAL.DISCOUNT_DISCLOSE' | translate }}:</span>
									</p>
									<ul
										*ngIf="
											professionalProfit.extraInfo.length > 0 &&
											(!isProfessionalZen ||
												(event?.isB2C && isProfessionalZen))
										"
										class="list-none"
									>
										<li
											*ngFor="let info of professionalProfit.extraInfo"
											class="aps-value flex"
										>
											<office-icon
												name="done-circle"
												size="20"
												style="margin-right: 8px"
											></office-icon>
											{{ info }}
										</li>
									</ul>
								</div>

								<!-- Voucher -->
								<div *ngIf="voucherDescription" class="aps-block">
									<p class="aps-title">
										{{ 'SCHEDULE.SESSIONVOUCHER' | translate }}:
									</p>
									<p class="aps-value">{{ voucherDescription }}</p>
								</div>

								<!-- Plans -->
								<div
									*ngIf="this.isPremium && !isProfessionalZen && event?.isB2C"
									class="aps-block know-our-plans"
								>
									<p
										class="font-medium"
										[innerHTML]="'SCHEDULE.KNOW_OUR_PLANS' | translate"
									></p>
								</div>
							</div>
						</div>
					</div>
				</ng-container>

				<ng-template #triageData>
					<h1 class="zk-mb-3 triage-title">{{ 'TRIAGE.TITLE' | translate }}</h1>
					<div class="zk-mb-3">
						<h2 class="triage-question">{{ 'TRIAGE.MOTIVES' | translate }}</h2>
						<span class="triage-answer">{{ formatTriageReasons() }}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.HAVE_EVER_DONE_TERAPY' | translate }}
						</h2>
						<span class="triage-answer">{{
							triage.alreadyHadTherapy ? 'Sim' : 'Não'
						}}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.MEDICATIONS' | translate }}
						</h2>
						<span class="triage-answer">{{
							triage.hasTakenMedication ? 'Sim' : 'Não'
						}}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.WHICH_MEDICATIONS' | translate }}
						</h2>
						<span class="triage-answer">{{
							triage.medicationName ? triage.medicationName : 'N/A'
						}}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.DESCRIBE_DAY_DIFICULTS' | translate }}
						</h2>
						<span class="triage-answer">{{ triage.pointOfLife }}</span>
					</div>
				</ng-template>

				<!-- Appointment not found. -->
				<div
					*ngIf="!isLoading && !eventFound && !busySlotFound && event"
					class="eventNotFound"
				>
					<fa-icon icon="info-circle"></fa-icon>
					{{ 'SCHEDULE.STATUS.NOTFOUND' | translate }}
				</div>
			</div>
			<div
				class="row"
				*ngIf="
					dateTime.dateTimeIsBefore(event?.dayEnd) &&
					!event.hasPromptuary &&
					event.status == 'paid' &&
					!event?.noShow
				"
			>
				<div class="warning-tag" *ngIf="!showTriageData">
					<span class="freud-icon freud-icon-info-circle"></span>
					<span>{{ 'GENERAL.NO_PROMPTUARY' | translate }}</span>
				</div>
			</div>
		</section>

		<!-- Footer -->
		<section
			[@enterAnimation]
			footer
			style="
				align-items: center;
				display: flex;
				justify-content: flex-end;
				flex-direction: column;
			"
		>
			<!-- Actions. -->
			<div class="apDetails-actions" id="apDetails-actions" *ngIf="!isLoading">
				<div
					*ngIf="!isValidatingStart"
					class="zk-flex zk-gap-2"
					[ngClass]="{
						'zk-px-4': showReceiptButton(),
						'zk-flex-row-reverse':
							dateTime.dateTimeIsBefore(event?.dayEnd) &&
							!event?.hasPromptuary &&
							event?.status == 'paid'
					}"
				>
					<freud-button
						*ngIf="
							dateTime.dateTimeIsBefore(event?.dayEnd) &&
							!event?.hasPromptuary &&
							!event?.noShow &&
							event?.status == 'paid'
						"
					>
						<a
							(click)="openPromptuarySidebar()"
							class="
								zk-no-underline
								hover:zk-no-underline
								zk-text-white
								freud-button-link
							"
							>{{ 'GENERAL.REGISTER_PROMPTUARY' | translate }}</a
						>
					</freud-button>

					<freud-button
						*ngIf="showTriageData"
						(click)="showAppointment()"
						color="secondary"
					>
						{{ 'TRIAGE.SEE_APPOINTMENT' | translate }}
					</freud-button>

					<freud-button
						*ngIf="dateTime.dateTimeIsAfter(event?.dayEnd) && !showTriageData"
						color="secondary"
					>
						<a
							(click)="trackPromptuaryListRedirect()"
							class="zk-no-underline hover:zk-no-underline freud-button-link"
							[href]="'contact/' + event?.contactId"
							>{{ 'GENERAL.SEE_PROMPTUARIES' | translate }}</a
						>
					</freud-button>

					<freud-button
						*ngIf="
							dateTime.dateTimeIsBefore(event?.dayEnd) && event?.hasPromptuary
						"
						color="secondary"
					>
						<a
							(click)="trackPromptuaryRedirect()"
							class="zk-no-underline hover:zk-no-underline freud-button-link"
							[href]="'promptuary/' + activeSidebar.id + '/' + event.profileId"
							>{{ 'GENERAL.SEE_PROMPTUARY' | translate }}</a
						>
					</freud-button>

					<freud-button
						*ngIf="event?.noShow"
						color="secondary"
						(click)="openPromptuarySidebar()"
					>
						<span>{{ 'GENERAL.SEE_PROMPTUARY' | translate }}</span>
					</freud-button>

					<!-- User triage. -->
					<ng-container *ngIf="triage$ | async as _triage">
						<freud-button
							*ngIf="hasTriage && !showTriageData"
							color="secondary"
							(click)="showTriage(_triage)"
						>
							{{ 'GENERAL.SEE_TRIAGE' | translate }}
						</freud-button>
					</ng-container>

					<app-receipt-button
						[event]="event"
						class="cursor-pointer"
						*ngIf="event && showReceiptButton() && !showTriageData"
						(onRequestGenerateReceipt)="closeEventSelected()"
					>
					</app-receipt-button>

					<freud-button
						*ngIf="dateTime.dateTimeIsBefore(event?.dayEnd)"
						[color]="
							dateTime.dateTimeIsBefore(event?.dayEnd) &&
							!event?.hasPromptuary &&
							event?.status == 'paid'
								? 'secondary'
								: 'primary'
						"
						(click)="schedule()"
					>
						{{ 'SCHEDULE.SCHEDULE_NEW_SESSION' | translate }}
					</freud-button>

					<freud-button
						(click)="handleDeleteClick()"
						*ngIf="busySlotFound"
						color="secondary"
					>
						{{ 'GENERAL.DELETE' | translate }}
					</freud-button>
					<freud-button
						(click)="openSidebarToEditBusySlot(busySlot)"
						*ngIf="busySlotFound"
					>
						{{ 'GENERAL.EDIT' | translate }}
					</freud-button>
					<freud-button
						*ngIf="
							dateTime.dateTimeIsAfter(event?.dayEnd) &&
							!event?.professionalAddress
						"
						(click)="allowConference && startConference()"
						[disabled]="!allowConference"
					>
						{{ 'GENERAL.ATTENDANCE' | translate }}
					</freud-button>
				</div>

				<div
					*ngIf="isValidatingStart"
					class="aps-block formButtons"
					style="
						align-items: center;
						display: flex;
						height: 34px;
						justify-content: center;
					"
				>
					<freud-loader size="sm" [bgColor]="false"></freud-loader>
				</div>
			</div>
		</section>
	</office-modal-container>
	<app-reasons-modal
		*ngIf="showReasonsModal"
		[event]="event"
		(onSave)="onReasonsSave()"
		(onCancel)="onReasonsCancel()"
		(onClose)="closeEventSelected()"
	></app-reasons-modal>
</office-modal>
<freud-confirm-dialog></freud-confirm-dialog>

<!-- CONFIRM DELETE BUSY SLOT MODAL -->
<office-modal [isOpen]="confirmDeleteBusySlot">
	<office-modal-container
		*ngIf="confirmDeleteBusySlot"
		[transparent]="true"
		[footerBorder]="true"
	>
		<!-- Header -->
		<div class="appointment-details--header" header *ngIf="!isLoading">
			<div class="zk-flex zk-justify-between zk-gap-2 zk-items-center">
				<div class="title zk-flex zk-gap-3">
					<h1 *ngIf="event || activeSidebar.type === 'busyslot'">
						{{ 'GENERAL.DELETE_RECURRENCY_EVENT' | translate }}
					</h1>
				</div>
			</div>
		</div>

		<!-- Body -->
		<section id="calendar-sidebar" class="appointment-details" body>
			<div class="options-container">
				<div class="zk-flex zk-gap-2 radio-item">
					<freud-radio-button
						[(ngModel)]="selectedOptionToDeleteBusySlot"
						[label]="'GENERAL.THIS_EVENT' | translate"
						[name]="'selectedOptionToDeleteBusySlot'"
						[radioValue]="'only'"
					></freud-radio-button>
				</div>
				<div class="radio-item">
					<freud-radio-button
						[(ngModel)]="selectedOptionToDeleteBusySlot"
						[label]="'GENERAL.THIS_AND_FUTURE_EVENTS' | translate"
						[name]="'selectedOptionToDeleteBusySlot'"
						[radioValue]="'future'"
					></freud-radio-button>
				</div>
				<div class="radio-item">
					<freud-radio-button
						[(ngModel)]="selectedOptionToDeleteBusySlot"
						[label]="'GENERAL.ALL_EVENTS' | translate"
						[name]="'selectedOptionToDeleteBusySlot'"
						[radioValue]="'all'"
					></freud-radio-button>
				</div>
			</div>
		</section>

		<!-- Footer -->
		<section
			footer
			style="
				align-items: center;
				display: flex;
				justify-content: flex-end;
				flex-direction: column;
			"
		>
			<!-- Actions. -->
			<div class="apDetails-actions" id="apDetails-actions">
				<div class="zk-flex zk-gap-2">
					<freud-button
						(click)="toggleConfirmDeleteBusySlot()"
						[color]="'secondary'"
					>
						{{ 'OPERATIONS.CANCEL' | translate }}
					</freud-button>
					<freud-button
						(click)="deleteBusySlot(busySlot.id, busySlot?.recurrencyId)"
					>
						{{ 'OPERATIONS.CONFIRM' | translate }}
					</freud-button>
				</div>
			</div>
		</section>
	</office-modal-container>
</office-modal>
